/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum GlobalMarket {
    Americas = 'Americas',
    Caribbean = 'Caribbean',
    AmericasAndCaribbean = 'Americas And Caribbean',
    UK = 'United Kingdom',
    Europe = 'Europe',
    AsiaPacific = 'Asia Pacific',
    Japan = 'Japan',
    RestOfWorld = 'Rest Of World',
    Worldwide = 'Worldwide',
}
